import { EmbeddedStyleStringTag } from './types';

/**
 * Builds the open-tag delimiter searched in the source text for a placeholder.
 *
 * @param {string} tagName - Bare tag name (without angle brackets), typically a value from `EmbeddedStylePlaceholderName`.
 * @returns {EmbeddedStyleStringTag} The delimiter in `<tagName>` form.
 *
 * @example
 * openTag('i'); // => '<i>'
 */
export const openTag = (tagName: string): EmbeddedStyleStringTag => `<${tagName}>`;

/**
 * Builds the close-tag delimiter searched in the source text for a placeholder.
 *
 * @param {string} tagName - Bare tag name (without angle brackets), typically a value from `EmbeddedStylePlaceholderName`.
 * @returns {EmbeddedStyleStringTag} The delimiter in `</tagName>` form.
 *
 * @example
 * closeTag('i'); // => '</i>'
 */
export const closeTag = (tagName: string): EmbeddedStyleStringTag => `</${tagName}>`;
